
export const logger = {
  log: (message: any) => {
    console.log(message);
  },
  error: (message: any) => {
    console.error(message);
  },
};
